// SakuraEffect.jsx
import React, { useEffect, useRef } from "react";

export default function SakuraEffectComp() {
  const canvasRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const container = containerRef.current;
    const ctx = canvas.getContext("2d");

    let width = container.offsetWidth;
    let height = container.offsetHeight;

    canvas.width = width;
    canvas.height = height;

    const petals = [];

    class Petal {
      constructor() {
        this.reset();
      }

      reset() {
        this.x = Math.random() * width;
        this.y = Math.random() * -height;
        this.size = Math.random() * 8 + 6;
        this.speedY = Math.random() * 1.5 + 0.7;
        this.speedX = Math.random() * 1 - 0.5;
        this.rotation = Math.random() * Math.PI * 2;
        this.rotateSpeed = Math.random() * 0.02 - 0.01;
        this.opacity = Math.random() * 0.4 + 0.5;
      }

      draw() {
        ctx.save();
        ctx.translate(this.x, this.y);
        ctx.rotate(this.rotation);

        ctx.beginPath();
        ctx.fillStyle = `rgba(255,182,193,${this.opacity})`;

        ctx.moveTo(0, 0);
        ctx.bezierCurveTo(-5, -5, -10, 5, 0, 12);
        ctx.bezierCurveTo(10, 5, 5, -5, 0, 0);
        ctx.fill();

        // sparkle
        ctx.beginPath();
        ctx.arc(0, 6, 1.2, 0, Math.PI * 2);
        ctx.fillStyle = "rgba(255,255,255,0.8)";
        ctx.fill();

        ctx.restore();
      }

      update() {
        this.y += this.speedY;
        this.x += this.speedX + Math.sin(this.y * 0.01);
        this.rotation += this.rotateSpeed;

        if (this.y > height + 20) {
          this.reset();
          this.y = -20;
        }

        this.draw();
      }
    }

    for (let i = 0; i < 30; i++) {
      petals.push(new Petal());
    }

    let animationFrame;

    const animate = () => {
      ctx.clearRect(0, 0, width, height);
      petals.forEach((petal) => petal.update());
      animationFrame = requestAnimationFrame(animate);
    };

    animate();

    const resize = () => {
      width = container.offsetWidth;
      height = container.offsetHeight;
      canvas.width = width;
      canvas.height = height;
    };

    window.addEventListener("resize", resize);

    return () => {
      cancelAnimationFrame(animationFrame);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        position: "absolute",
        inset: 0,
        overflow: "hidden",
        pointerEvents: "none",
        zIndex: 1,
      }}
    >
      <canvas
        ref={canvasRef}
        style={{
          width: "100%",
          height: "100%",
        }}
      />
    </div>
  );
}